// Core
import { DateTime } from "luxon";
import moment from "moment";
// Utils
import { GRANULARITY_LEVELS } from "./constants/time";

export function datetimeToDate(datetime) {
  if (!datetime) return "-";
  const dt = DateTime.fromISO(datetime, { setZone: true });
  return dt.toFormat("yyyy-MM-dd");
}

export function datetimeToDateNoUTC(datetime) {
  return moment(datetime).format("YYYY-MM-DD");
}

export function datetimeToTime(datetime) {
  if (!datetime) return "-";
  const dt = DateTime.fromISO(datetime, { setZone: true });
  return dt.toFormat("HH:mm ZZZZ");
}

export function formatDateTime(datetime) {
  if (!datetime) return "-";
  const dt = DateTime.fromISO(datetime, { setZone: true });
  return dt.toFormat("yyyy-MM-dd HH:mm ZZZZ");
}

export function today() {
  return DateTime.now().toUTC().toISO();
}

export function yesterday() {
  return DateTime.now().minus({ days: 1 }).toUTC().toISO();
}

export function tomorrow() {
  return DateTime.now().plus({ days: 1 }).toUTC().toISO();
}

export function getDateFromDatetime(datetime) {
  return new Date(datetime).getDate();
}

export function getMonthFromDatetime(datetime) {
  return new Date(datetime).getMonth();
}

export function getYearFromDatetime(datetime) {
  return new Date(datetime).getFullYear();
}

/**
 * Utility function to limit the granularity levels for performance reasons.
 */
export function getGranularityLevels(timeHorizonInDays) {
  if (timeHorizonInDays <= 1) {
    return GRANULARITY_LEVELS;
  }
  if (timeHorizonInDays <= 7) {
    return GRANULARITY_LEVELS.slice(1);
  }
  if (timeHorizonInDays <= 180) {
    return GRANULARITY_LEVELS.slice(2);
  }
  if (timeHorizonInDays <= 365) {
    return GRANULARITY_LEVELS.slice(3);
  }

  return GRANULARITY_LEVELS.slice(3);
}

/**
 * Default granularity for a date range: the finest level that keeps the point
 * count sensible for that span (≤1d→15min, ≤7d→hour, ≤180d→day, else month).
 * The backend always requires a granularity, so this is the implicit default
 * used everywhere instead of a manual selector.
 */
export function autoGranularity(startDate, endDate) {
  const days = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);
  const safeDays = Number.isFinite(days) ? Math.max(0, days) : 0;
  return getGranularityLevels(safeDays)[0].value;
}

export function H1GranularityToMIN15(data) {
  const newData = [];
  data?.forEach((item) => {
    const baseDateTime = new Date(item?.datetime_timestamp);
    for (let i = 0; i < 4; i += 1) {
      const newItem = { ...item };
      newItem.datetime_timestamp = DateTime.fromJSDate(new Date(baseDateTime))
        .plus({ minutes: i * 15 })
        .toISO();
      newData.push(newItem);
    }
  });
  return newData;
}
